import React, {useState, useRef} from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import {Grid, Box as MuiBox} from '@material-ui/core';
// import ReactHtmlParser from 'react-html-parser';
import {ReactSVG} from 'react-svg';
import Modal from '../../ui/Modal';

import {RespImg, Cta} from '../../ui';
import {theme} from '../../../themes/default-theme';
import Text from '../../typography';
import YoutubeVideo from '../YoutubeVideo';

import playIcon from '../../../assets/icons/play-icon-new.svg';
import HtmlParser from '../../ui/HtmlParser';



const PlayBtn = styled.div`
  position: absolute;
  z-index: 2;
  left:0;
  top:0;
  width:100%;
  height:100%;
  cursor:pointer;
  svg {
    right:20px;
    bottom:20px;
    position:absolute;
  }
  ${theme.breakpoints.down("sm")} {
    display:none;
  }
`

const Container = styled.div`
  overflow: hidden;
  position: relative;

  ${theme.breakpoints.up("lg")} {
    min-height: 650px;
    max-width: ${theme.containers.full.width};
    margin: 0 auto;
  }
`

const BgAssetWrapper = styled.div`
  position: relative;
  overflow: hidden;
  ${theme.breakpoints.only("md")} {
    height: 530px;
    position: relative;
  }
  > div {
    ${theme.breakpoints.down("sm")} {
      display:block;
    }
  }

  ${theme.breakpoints.up("md")} {
    picture,
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      width: auto;
      height: auto;
      max-height: none;
      max-width: none;
      min-height: 650px;
      max-height: 650px;
      min-width: 100%;
      transform: translate(-50%, -50%); 
    }
  }

  ${theme.breakpoints.up("lg")} {   
    position: absolute;
    top: 50%;
    left: 50%;
    width: auto;
    height: auto;
    max-height: none;
    min-height: 100%;
    min-width: 100%;
    transform: translate(-50%, -50%);
  }
`

const VideoWrapper = styled.div`
  height: 0;
  padding-top: 46.25%;

  ${theme.breakpoints.up("md")} {
    height: auto;
    padding: 0;
  }
`

const Video = styled.video`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);

  ${theme.breakpoints.down("sm")} {
    width: 100%;
  }
`

const Wrapper = styled.div`

`

const Heading = styled(props => {
  return <Text {...props} />
})`
  margin-bottom: 10px;
  ${theme.breakpoints.up("md")} {
    text-align: center;
    margin-bottom: 50px;
  }
`

const Content = styled.div`
  position: relative;

  ${theme.breakpoints.up("md")} {
    z-index: 1;
    position: absolute;
    left:50%;
    top:50%;
    transform:translate(-50%, -50%);
    width:100%;
    padding-left: 36px;
    padding-right: 36px;

    &:before,
    &:after {
      display: table;
      content: ' ';
    }

    &:after {
      clear: both
    }
  }

  ${theme.breakpoints.up("lg")} {
    padding-left: 84px;
    padding-right: 84px;
  }

  ${props => props.backgroundColor === 'light' ? `      
      h2, p {
        ${theme.breakpoints.up("md")} {
          color:${theme.palette.white};
        }
      }
    ` : 
    `
      ${theme.breakpoints.down("sm")} {
        background-color:${theme.palette.black};
        h2, p, div {
          color:${theme.palette.white};
        }
      }
      ` 
  };
`


const Box = styled.div`
  ${theme.breakpoints.up("md")} {

  }
`

const BoxContent = styled.div`
  padding 0 ${theme.containers.main.gutter};
  margin-top: 20px;

  ${theme.breakpoints.down("sm")} {
    text-align:center;
  }
  h6 {
    font-size:12px;
    line-height:16px;
    margin-bottom:5px;
    ${theme.breakpoints.up("md")} {
      font-size:14px;
      line-height:19px;
    }
  }
  h2 {
    font-size:18px;
    line-height:24px;
    margin-bottom:10px;
    ${theme.breakpoints.up("md")} {
      font-size:21px;
      line-height:24px;
      margin-bottom:15px;
      color:${theme.palette.white};
    }
    ${theme.breakpoints.up("lg")} {
      font-size:34px;
      line-height:38px;
    }
  }
  div {
    ${theme.breakpoints.up("md")} {
      color:${theme.palette.white};
    }
  }
  a {
    text-decoration: none;
  }

  picture, image { 
    ${theme.breakpoints.down("sm")} {
      display:none;
    }
  }
  
`

const OverlayVideoContainer = styled.div`
  width: 100%;
  max-width: 1066px;
  margin: 0 auto;
`

const OverlayVideoWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(0,0,0,0.5);
`

const BoxContentText = styled(Text)`
  margin: 15px 0;
  text-align:center;
  ${theme.breakpoints.down("sm")} {
    font-size: 13px;
  }
`


const CTAContainer = styled.div`
  margin-top:35px;
  text-align:center;
  ${theme.breakpoints.down("sm")} {
    margin-top:25px;
  }
  a {
    display:inline-block;
    width:auto;
    margin:auto;
  }
`

const FitVid = styled.div`
  height: 0;
  position: relative;

`

const MediaBanner = (props) => {
  const {
    background,
    pretitle,
    title,
    text,
    logo,
    image,
    video,
    cta
  } = props

  const [modal, openModal] = useState(false);

  const handleModal = (e, val) => {

    openModal(val ? val : !modal);
    
  }

  const PlayButton = () => (
    <PlayBtn onClick={handleModal} play large>
      <ReactSVG src={playIcon} />
    </PlayBtn>
  );

  console.log('media banner props', props);

  return (
    <Wrapper>

      {video &&
        <Modal
          isOpen={modal}
          onClose={(e) => handleModal(e, false)}
        >
          <OverlayVideoContainer>
            {/* {video.indexOf('.mp4') !== -1 || video.indexOf('.mp4')}
            <YoutubeVideo
              url={video}
              autoPlay
            /> */}
            {modal &&
              <FitVid style={{paddingTop: `56.25%`}}>

                <Video autoPlay controls>
                  <source src={video} />
                </Video>
              </FitVid>
            }
          </OverlayVideoContainer>
        </Modal>
      }
      <Container> 
        {video &&  <PlayButton />
        }       
        <BgAssetWrapper>
          {video &&  <PlayButton />
          } 
          <RespImg 
          {...image}
          />
        </BgAssetWrapper>
        <Content backgroundColor={background}>
          <Box>
            <Grid container justify={'flex-start'} spacing={0} direction={'row'} wrap="nowrap" align={'flex-start'}>
              <Grid item xs={12} md={6} lg={5}> 
                <BoxContent backgroundColor={background}>
                  {pretitle &&
                    <Text variant="h6" colour="vividBlue" uppercase="true" align="center">{pretitle}</Text>
                  }
                  {title &&
                    <Text variant="h2" uppercase="true" align="center">{title}</Text>
                  }
                  {logo && 
                    <RespImg 
                      {...logo} 
                      type="png"
                      />
                  }
                  {text && <BoxContentText variant="body1"><div><HtmlParser html={text} /></div></BoxContentText> }
                  
                </BoxContent>                
              </Grid>
            </Grid>
          </Box>
        </Content>
      </Container>
      {(cta && cta.title) &&
        <CTAContainer>
          <Box px={2}>
            <Cta primary href={cta.href || '#'}>
              {cta.title}
            </Cta>
          </Box>
        </CTAContainer>
      }
    </Wrapper>
  )
}
  
MediaBanner.propTypes = {
  background: propTypes.string,
  pretitle: propTypes.string,
  title: propTypes.string,
  text: propTypes.string,
  logo: propTypes.object,
  image: propTypes.object,
  video: propTypes.string,
  cta: propTypes.object
}
  
MediaBanner.defaultProps = { 
  background: null, 
  pretitle: null,
  title: null,
  text: null,
  logo: null,
  image :null,
  video: null ,
  cta: null
}
  
export default MediaBanner
